import { render } from "./EnElMundoView.vue?vue&type=template&id=1119be92"
import script from "./EnElMundoView.vue?vue&type=script&lang=js"
export * from "./EnElMundoView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__